export default (state = null, { type, payload }) => {
  switch (type) {
  case 'LOGIN':
    return payload
  case 'EXPIRED_TOKEN_LOGOUT':
    return { forceLogOut: true }
  case 'LOGOUT':
    return null
  default:
    return state
  }
}
